import { render, staticRenderFns } from "./UsermanagementKunde.vue?vue&type=template&id=5834d04d"
import script from "./UsermanagementKunde.vue?vue&type=script&lang=js"
export * from "./UsermanagementKunde.vue?vue&type=script&lang=js"
import style0 from "./UsermanagementKunde.vue?vue&type=style&index=0&id=5834d04d&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5834d04d')) {
      api.createRecord('5834d04d', component.options)
    } else {
      api.reload('5834d04d', component.options)
    }
    module.hot.accept("./UsermanagementKunde.vue?vue&type=template&id=5834d04d", function () {
      api.rerender('5834d04d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UsermanagementKunde.vue"
export default component.exports